import starImg from '../../components/atomic/icons/star/star.png';
import './StarIcon.css';

/** From Figma icon_star (154:32586) — 383 988.63 180.16×173.99, rotate −6.16°. */
export function StarIcon() {
  return (
    <img
      className="rating-star-icon"
      src={starImg}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
